import axios from "axios";

const apiUzapi = axios.create({
  baseURL: process.env.REACT_APP_UZAPI_URL,
});

export default apiUzapi;
